/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetOrganizationRemoteSessionIssuerDeletePreflightSecurity = {
  sessionHeaderGramSession?: string | undefined;
  apikeyHeaderGramKey?: string | undefined;
};

export type GetOrganizationRemoteSessionIssuerDeletePreflightRequest = {
  /**
   * The remote_session_issuer id.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
};

/** @internal */
export type GetOrganizationRemoteSessionIssuerDeletePreflightSecurity$Outbound =
  {
    "session_header_Gram-Session"?: string | undefined;
    "apikey_header_Gram-Key"?: string | undefined;
  };

/** @internal */
export const GetOrganizationRemoteSessionIssuerDeletePreflightSecurity$outboundSchema:
  z.ZodMiniType<
    GetOrganizationRemoteSessionIssuerDeletePreflightSecurity$Outbound,
    GetOrganizationRemoteSessionIssuerDeletePreflightSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
      apikeyHeaderGramKey: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
      });
    }),
  );

export function getOrganizationRemoteSessionIssuerDeletePreflightSecurityToJSON(
  getOrganizationRemoteSessionIssuerDeletePreflightSecurity:
    GetOrganizationRemoteSessionIssuerDeletePreflightSecurity,
): string {
  return JSON.stringify(
    GetOrganizationRemoteSessionIssuerDeletePreflightSecurity$outboundSchema
      .parse(getOrganizationRemoteSessionIssuerDeletePreflightSecurity),
  );
}

/** @internal */
export type GetOrganizationRemoteSessionIssuerDeletePreflightRequest$Outbound =
  {
    id: string;
    "Gram-Session"?: string | undefined;
    "Gram-Key"?: string | undefined;
  };

/** @internal */
export const GetOrganizationRemoteSessionIssuerDeletePreflightRequest$outboundSchema:
  z.ZodMiniType<
    GetOrganizationRemoteSessionIssuerDeletePreflightRequest$Outbound,
    GetOrganizationRemoteSessionIssuerDeletePreflightRequest
  > = z.pipe(
    z.object({
      id: z.string(),
      gramSession: z.optional(z.string()),
      gramKey: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        gramKey: "Gram-Key",
      });
    }),
  );

export function getOrganizationRemoteSessionIssuerDeletePreflightRequestToJSON(
  getOrganizationRemoteSessionIssuerDeletePreflightRequest:
    GetOrganizationRemoteSessionIssuerDeletePreflightRequest,
): string {
  return JSON.stringify(
    GetOrganizationRemoteSessionIssuerDeletePreflightRequest$outboundSchema
      .parse(getOrganizationRemoteSessionIssuerDeletePreflightRequest),
  );
}
